// extracted by css-extract-rspack-plugin
export default {"listItem":"content-editor-plugin-list-item-ListItem-listItem-28fb76af"};